import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCaptureFinixTransactionsRequestSchema,
  TCaptureFinixTransactionsResponseSchema,
} from "./captureFinixTransactions.schema";

export const captureFinixTransactions = (axios: IAxiosInstance) => {
  return async (body: TCaptureFinixTransactionsRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCaptureFinixTransactionsResponseSchema>
    >(`/api/business-cards/transactions/capture`, body);

    return response.data;
  };
};
